// extracted by mini-css-extract-plugin
export default {"dateInput":"customDatePicker_dateInput__nqQJy","fullWidth":"customDatePicker_fullWidth__aOr+f"};